// Curash Wishlist — localStorage-based.
// Public API: window.CurashWishlist.{has, add, remove, toggle, list, count, on}
(function () {
  var KEY = 'curash:wishlist:v1';
  var SEEN_TOAST_KEY = 'curash:wishlist:welcomed';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      // quota exceeded or storage disabled - silently ignore
    }
  }

  var listeners = [];
  function emit() {
    var snapshot = read();
    listeners.forEach(function (fn) {
      try { fn(snapshot); } catch (e) { /* ignore */ }
    });
    // also fire a DOM event so any non-JS subscribers can react
    document.dispatchEvent(new CustomEvent('curash:wishlist:change', { detail: { items: snapshot } }));
  }

  var Wishlist = {
    list: function () { return read(); },
    count: function () { return read().length; },
    has: function (id) {
      if (id == null) return false;
      var key = String(id);
      return read().some(function (it) { return String(it.id) === key; });
    },
    add: function (product) {
      if (!product || product.id == null) return false;
      var items = read();
      var key = String(product.id);
      if (items.some(function (it) { return String(it.id) === key; })) return false;
      items.unshift({
        id: product.id,
        handle: product.handle || '',
        title: product.title || '',
        url: product.url || '',
        image: product.image || '',
        image2: product.image2 || '',
        price: product.price || '',
        colors: product.colors || '',
        swatches: product.swatches || '',
        variantId: product.variantId || '',
        productData: product.productData || '',
        addedAt: new Date().toISOString()
      });
      write(items);
      emit();
      return true;
    },
    remove: function (id) {
      if (id == null) return false;
      var key = String(id);
      var items = read();
      var next = items.filter(function (it) { return String(it.id) !== key; });
      if (next.length === items.length) return false;
      write(next);
      emit();
      return true;
    },
    toggle: function (product) {
      if (!product || product.id == null) return false;
      if (Wishlist.has(product.id)) {
        Wishlist.remove(product.id);
        return false;
      } else {
        Wishlist.add(product);
        return true;
      }
    },
    on: function (fn) {
      if (typeof fn !== 'function') return function () {};
      listeners.push(fn);
      return function off() {
        listeners = listeners.filter(function (l) { return l !== fn; });
      };
    },
    showToast: function (message) {
      var toast = document.createElement('div');
      toast.className = 'curash-wishlist-toast';
      toast.textContent = message;
      document.body.appendChild(toast);
      // force reflow so the transition runs
      void toast.offsetHeight;
      toast.classList.add('is-visible');
      setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { toast.remove(); }, 350);
      }, 1800);
    },
    welcomeBackIfNeeded: function () {
      var count = Wishlist.count();
      if (count === 0) return;
      // Don't toast on the wishlist page itself
      if (location.pathname.indexOf('/pages/wishlist') !== -1) return;
      try {
        if (sessionStorage.getItem(SEEN_TOAST_KEY)) return;
        sessionStorage.setItem(SEEN_TOAST_KEY, '1');
      } catch (e) { return; }
      var noun = count === 1 ? 'item' : 'items';
      Wishlist.showToast('Welcome back — ' + count + ' ' + noun + ' waiting in your wishlist');
    }
  };

  // Cross-tab sync: another tab updated the wishlist, refresh ours
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) emit();
  });

  window.CurashWishlist = Wishlist;

  // Init: emit once so any UI listening at boot can paint, then welcome-back toast
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      emit();
      Wishlist.welcomeBackIfNeeded();
    });
  } else {
    emit();
    Wishlist.welcomeBackIfNeeded();
  }
})();
